import { IconTrash } from '@tabler/icons-react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

/** Recently generated codes, saved locally on every download. */
export default function QrHistoryCard({ history, onOpen, onDelete, onClearAll, onSaveCurrent, canSave }) {
    const { t, currentLanguage } = useTranslation();
    const locale = currentLanguage === 'bn' ? 'bn-BD' : 'en-GB';

    return (
        <div className="rounded-[20px] border border-[#ECE8E4] bg-white p-[18px] shadow-[0_1px_2px_rgba(28,24,21,0.04)] dark:border-zinc-700 dark:bg-zinc-900">
            <div className="mb-3 flex items-center gap-2.5">
                <span className="text-[14px] font-bold text-[#1C1815] dark:text-zinc-100">{t('qrCode.historyTitle')}</span>
                <button
                    type="button"
                    onClick={onSaveCurrent}
                    disabled={!canSave}
                    className="ml-auto h-8 rounded-[10px] border border-[#ECE8E4] bg-white px-3 text-[12px] font-semibold text-[#3D3833] transition-colors hover:border-primary/40 hover:text-primary disabled:opacity-50 disabled:hover:border-[#ECE8E4] disabled:hover:text-[#3D3833] dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300"
                >
                    {t('qrCode.historySave')}
                </button>
                {history.length > 0 ? (
                    <button
                        type="button"
                        onClick={onClearAll}
                        className="h-8 rounded-[10px] border border-[#ECE8E4] bg-white px-3 text-[12px] font-semibold text-[#D33A2C] transition-colors hover:border-[#D33A2C]/40 dark:border-zinc-700 dark:bg-zinc-900"
                    >
                        {t('qrCode.historyClearAll')}
                    </button>
                ) : null}
            </div>

            {history.length === 0 ? (
                <p className="text-[12.5px] text-[#6B635B] dark:text-zinc-400">{t('qrCode.historyEmpty')}</p>
            ) : (
                // Past two rows the list scrolls inside the card, with the third
                // row half in view so it is clear there is more.
                <div className={`flex flex-col gap-2 ${history.length > 2 ? 'max-h-[135px] overflow-y-auto overscroll-contain pr-1' : ''}`}>
                    {history.map((entry) => (
                        <div
                            key={entry.id}
                            className="flex items-center gap-2.5 rounded-[13px] border border-[#ECE8E4] bg-[#FBFAF9] p-2.5 dark:border-zinc-700 dark:bg-zinc-800/60"
                        >
                            <img
                                src={entry.thumbnail}
                                alt=""
                                className="h-10 w-10 flex-none rounded-lg border border-[#ECE8E4] bg-white object-cover dark:border-zinc-700"
                            />
                            <div className="min-w-0 flex-1">
                                <div className="truncate text-[12.5px] font-semibold text-[#1C1815] dark:text-zinc-100">
                                    {entry.payload}
                                </div>
                                <div className="text-[11px] text-[#6B635B] dark:text-zinc-400">
                                    {t(`qrCode.types.${entry.type}`)} · {new Date(entry.ts).toLocaleDateString(locale)}
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={() => onOpen(entry)}
                                className="h-[30px] flex-none rounded-[9px] border border-[#ECE8E4] bg-white px-2.5 text-[11.5px] font-semibold text-[#3D3833] transition-colors hover:border-primary/40 hover:text-primary dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300"
                            >
                                {t('qrCode.historyOpen')}
                            </button>
                            <button
                                type="button"
                                onClick={() => onDelete(entry.id)}
                                aria-label={t('common.delete')}
                                className="flex h-[26px] w-[26px] flex-none items-center justify-center rounded-lg border border-[#ECE8E4] bg-white text-[#D33A2C] transition-colors hover:border-[#D33A2C]/40 dark:border-zinc-700 dark:bg-zinc-900"
                            >
                                <IconTrash size={13} stroke={1.9} />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
